import React from "react";

import ReactModal from "react-modal";

import { styles } from "./styles";

/**
 * @param {{
 *   isOpen: boolean,
 *   label: string,
 *   children: React.ReactNode,
 *   onClose: () => void,
 *   closable?: boolean,
 *   customStyles?: { overlay?: Record<string, unknown>, content?: Record<string, unknown> },
 * }} props
 */
const Modal = ({
  isOpen,
  label,
  children,
  onClose,
  closable = true,
  customStyles,
}) => {
  const mergedStyles = customStyles
    ? {
        overlay: { ...styles.overlay, ...(customStyles.overlay || {}) },
        content: { ...styles.content, ...(customStyles.content || {}) },
      }
    : styles;
  return (
    <ReactModal
      isOpen={isOpen}
      contentLabel={label}
      onRequestClose={onClose}
      bodyOpenClassName="overflow-hidden"
      style={mergedStyles}
      shouldCloseOnEsc={closable}
      shouldCloseOnOverlayClick={closable}
    >
      {children}
    </ReactModal>
  );
};

export default Modal;
